/** @jsx jsx */
import { jsx } from "theme-ui"
import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Image from "gatsby-image"
import * as Styles from "./styles/mainContainer"
import { useColorMode } from "theme-ui"

import { rhythm } from "../utils/typography"
import { GlobalStyle } from "./styles/GlobalStyles"

const MainContainer = ({
  children,
  heading = "Default Heading",
  tagLine = "Default Tagline",
}) => {
  const [colorMode, setColorMode] = useColorMode()
  return (
    <Styles.MainContainer>
      <GlobalStyle />
      <Styles.MainHeaderWrapper>
        <Styles.PageHeader>{heading}</Styles.PageHeader>
        {/* <button
          style={{ float: "right" }}
          onClick={e => {
            setColorMode(colorMode === "yellow" ? "dark" : "default")
          }}
        >
          change
        </button>
        <button
          style={{ float: "right" }}
          onClick={e => {
            setColorMode("yellow")
          }}
        >
          yellow
        </button>
        <p
          sx={{
            color: "dark",
          }}
        >
          this is text
        </p> */}
        <Styles.PageTagLine>{tagLine}</Styles.PageTagLine>
      </Styles.MainHeaderWrapper>
      <Styles.MainBodyWrapper>{children}</Styles.MainBodyWrapper>
    </Styles.MainContainer>
  )
}

export default MainContainer
